
export const saveSubjectName = (id, name) => {
  const val = localStorage.getItem('subject_names');

  const rec = val ? JSON.parse(val) : [];

  const item = rec.find(i => i.id == id);
  
  if (item) {
    item.name = name;
  } else {
    if (rec.length > 10000-1){
      rec.shift();
    }

    rec.push({id, name});
  }

  localStorage.setItem('subject_names', JSON.stringify(rec)); // ストレージ保存
  
}

export const findSubjectName = (id) => {
  const val = localStorage.getItem('subject_names');

  const rec = val ? JSON.parse(val) : [];

  const item = rec.find(i => i.id == id);

  return item ? item.name : '';
}
